<div class="jumbotron bg-white ">
    <div class="container">
        <div class="row">
            <div class="col-md-6 offset-md-3">

<!-- Pulsing Dots Spinner Overlay -->
<div *ngIf="loading" class="spinner-overlay">
    <div class="dots-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>
<form [formGroup]="registerForm" class="text-center border  p-5">

    <p class="h4 mb-4">Register</p>

    <!--{{registerForm.value | json}}-->
    <div class="form-group">
        <label class="float-left" translate>First Name</label>
        <input type="text" formControlName="firstName" class="form-control" [class.is-invalid]="formErrors.firstName" (blur)="logValidationErrors(registerForm)" />
        <div  [class.d-none]="!formErrors.firstName">
            <small>{{formErrors.firstName}}</small></div>
    </div>

    <div class="form-group">
        <label class="float-left" translate>Middle Name</label>
        <input type="text" formControlName="middleName" class="form-control" />
     
    </div>

    <div class="form-group">
        <label class="float-left" translate>Last Name</label>
        <input type="text" formControlName="lastName" class="form-control" [class.is-invalid]="formErrors.lastName" (blur)="logValidationErrors(registerForm)" />
        <div  [class.d-none]="!formErrors.lastName">
            <small>{{formErrors.lastName}}</small></div>
    </div>
    <div class="form-group">
        <label class="float-left" translate>Email</label>
        <input type="text" formControlName="email" class="form-control" />
        
    </div>
 

    <!--  (change)='getAssetUser($event.target.value,"")'-->
        <div class="row px-3 form-group ">
           
            <label class="float-left" translate>Branch</label>
            <select class=" form-control select2 select2-hidden-accessible"
                formControlName="branch" id="branch" name="branch"
                 tabindex="-1" aria-hidden="true"
                [class.is-invalid]="formErrors.branch" (change)="getUserExpertiseForFormByLocation($event.target.value)"
                (blur)="logValidationErrors(registerForm)"  >
                <option value=""  disabled selected>Select</option>
                <option data-tagprefix=''*ngFor='let branchs of branchCategories' value={{branchs.name}}>{{branchs.name}}</option>
          <!--      <option data-tagprefix='' value='Agency'>Agency</option>
                <option data-tagprefix='' value='Employee'>Employee</option>
                <option data-tagprefix='' value='Management'>Management</option>
                <option data-tagprefix='' value='Reporter'>Reporter</option>
                <option data-tagprefix='' value='Team Lead'>Team Lead</option>
                <option data-tagprefix='' value='Tech Support'>Tech Support</option>-->
                

            </select>        
        </div>

        <div class="row px-3 form-group ">
           
            <label class="float-left" translate>Role</label>
            <select class=" form-control select2 select2-hidden-accessible"
                formControlName="role" id="role" name="role"
                 tabindex="-1" aria-hidden="true"
                [class.is-invalid]="formErrors.role"
                (blur)="logValidationErrors(registerForm)"  >
                <option value=""  disabled selected>Select</option>
                <option data-tagprefix=''*ngFor='let roles of roleCategories' value={{roles.name}}>{{roles.name}}</option>
          <!--      <option data-tagprefix='' value='Agency'>Agency</option>
                <option data-tagprefix='' value='Employee'>Employee</option>
                <option data-tagprefix='' value='Management'>Management</option>
                <option data-tagprefix='' value='Reporter'>Reporter</option>
                <option data-tagprefix='' value='Team Lead'>Team Lead</option>
                <option data-tagprefix='' value='Tech Support'>Tech Support</option>-->
                

            </select>        
        </div>
    
         
        <div class="row pl-3 pt-2 form-group" >
       
            <input type="text" formControlName="userID" class="col-sm-10 form-control " placeholder="Username" translate>
            <ngx-colors *ngIf="registerForm.value.role=='Sales Representative' || registerForm.value.role=='Administrator' || registerForm.value.role=='Manager' || registerForm.value.role=='Management' || registerForm.value.role=='Power User' "  ngx-colors-trigger class="col-sm-2"  formControlName="color"></ngx-colors>
      
        </div>

    
        <div class="row pl-3 pt-2 form-group"  style="font-family: DinPro;"  *ngIf="registerForm.value.role=='Sales Representative' || registerForm.value.role=='Administrator' || registerForm.value.role=='Manager' || registerForm.value.role=='Management' || registerForm.value.role=='Power User' || registerForm.value.role=='Sales Support'" >
            <label class="w-100 font-weight-bolder text-left border-bottom "> Expertise</label>
        <label class="m-2" *ngFor="let ex of expertise">
            <input type="checkbox" [value]="ex.name" (change)="onExpertiseChange(ex.name, $event)"/> {{ex.name}}
          </label>
  </div>


    <button class="btn btn-info my-4 btn-block" (click)='registerUser();' type="submit" translate>Register</button>

    <hr>

</form>

</div>
</div>
</div>
</div>


<!-------------------------------------------------------------------------------------------------------------------->
<button id="openSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-success" translate>SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-success">
                <p translate>User Account has been created.</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="backClicked()"
                    data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>
</div>

<!-------------------------------------------------------------------------------------------------------------------->

<button id="opennErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal1">Open Modal</button>
<!-- Modal -->
<div id="ErrorModal1" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-danger" translate>ERROR</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-danger">
                <p>{{error}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="backClicked()"
                    data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>
</div>